import { HTMLProps, ReactNode, useState } from 'react'
import clsx from 'classnames'
import { IHistoryPoint } from '@/interfaces/blocks'
import { Button } from '@/shared/ui'
import style from './timeline-item.module.scss'
import { Text } from '../../text'
import { Document } from '../../document'

interface TimelineItemProps extends Omit<HTMLProps<HTMLLIElement>, 'summary' | 'title'>, IHistoryPoint {
  navigation: ReactNode
}

export const TimelineItem = (props: TimelineItemProps) => {
  const { className, year, summary, title, description, documents, navigation } = props
  const [isShowMore, setIsShowMore] = useState(false)
  const canShowMore = (documents?.length || 0) > 3
  return (
    <li className={clsx(style.container, className)}>
      <div className={style.startColumn}>
        <Text className={style.year} color="main-blue">
          {year}
        </Text>
        <div className="text text_type_t2 text_color_main-blue" dangerouslySetInnerHTML={{ __html: summary }} />

        {navigation}
      </div>

      <div className={style.endColumn}>
        <Text className={style.title} type="h2" color="dark">
          {title}
        </Text>
        <div className="text text_type_t2 text_color_dark" dangerouslySetInnerHTML={{ __html: description }} />

        {!!documents?.length && (
          <div className={clsx(style.downloadList, { [style.showMore]: isShowMore })}>
            {documents?.map(({ name, file }) => (
              <Document
                key={file.id}
                className={clsx(style.documentItem, 'text text_type_t2 text_color_main-blue')}
                href={file.url}
              >
                {name || file.title}
              </Document>
            ))}

            {canShowMore && !isShowMore && (
              <Button className={style.showMoreBtn} onClick={() => setIsShowMore(true)}>
                Смотреть все
              </Button>
            )}
          </div>
        )}
      </div>
    </li>
  )
}
